module.exports = __webpack_public_path__ + "img/whiteboard.13273948.svg";